/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { errorActualConfig } from '../../config/error.config';
export interface IErrorActualPluginMethods extends IPluginMethodMap {
  getErrorActualSync(args?: any): any;
}

export class ErrorActualPlugin implements IAgentPlugin {
  readonly methods: IErrorActualPluginMethods;

  constructor() {
    this.methods = {
      getErrorActualSync: this.getErrorActualSync.bind(this),
    };
  }

  getErrorActualSync(args?: any) {
    return {
      error: errorActualConfig,
    };
  }
}
